import AuditLogForm from "../../components/views/audit-logs";

function AuditLogPage() {
  return <AuditLogForm />;
}

export default AuditLogPage;
